import { createContext } from 'react';
import type EditUserContext from 'types/contexts/EditUserContext';

export default createContext({} as EditUserContext);
